import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Pagination/pagination';
import { css } from '@patternfly/react-styles';
import AngleLeftIcon from '@patternfly/react-icons/dist/js/icons/angle-left-icon';
import AngleDoubleLeftIcon from '@patternfly/react-icons/dist/js/icons/angle-double-left-icon';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
import AngleDoubleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-double-right-icon';
import { Button, ButtonVariant } from '../Button';
import { pluralize } from '../../helpers';
import { KEY_CODES } from '../../helpers/constants';
export var Navigation =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Navigation, _React$Component);

  function Navigation(props) {
    var _this;

    _classCallCheck(this, Navigation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Navigation).call(this, props));

    _this.handleNewPage = function (_evt, newPage) {
      var _this$props = _this.props,
          perPage = _this$props.perPage,
          onSetPage = _this$props.onSetPage;
      var startIdx = (newPage - 1) * perPage;
      var endIdx = newPage * perPage;
      return onSetPage(_evt, newPage, perPage, startIdx, endIdx);
    };

    _this.state = {
      userInputPage: _this.props.page
    };
    return _this;
  }

  _createClass(Navigation, [{
    key: "onChange",
    value: function onChange(event, lastPage) {
      var inputPage = Navigation.parseInteger(event.target.value, lastPage);
      this.setState({
        userInputPage: Number.isNaN(inputPage) ? event.target.value : inputPage
      });
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event, page, lastPage, onPageInput) {
      if (event.keyCode === KEY_CODES.ENTER) {
        var inputPage = Navigation.parseInteger(this.state.userInputPage, lastPage);
        onPageInput(event, Number.isNaN(inputPage) ? page : inputPage);
        this.handleNewPage(event, Number.isNaN(inputPage) ? page : inputPage);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(lastState) {
      if (this.props.page !== lastState.page && this.props.page <= this.props.lastPage && this.state.userInputPage !== this.props.page) {
        this.setState({
          userInputPage: this.props.page
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          page = _a.page,
          perPage = _a.perPage,
          onSetPage = _a.onSetPage,
          isDisabled = _a.isDisabled,
          lastPage = _a.lastPage,
          firstPage = _a.firstPage,
          pagesTitle = _a.pagesTitle,
          toLastPage = _a.toLastPage,
          toNextPage = _a.toNextPage,
          toFirstPage = _a.toFirstPage,
          toPreviousPage = _a.toPreviousPage,
          currPage = _a.currPage,
          paginationTitle = _a.paginationTitle,
          onNextClick = _a.onNextClick,
          onPreviousClick = _a.onPreviousClick,
          onFirstClick = _a.onFirstClick,
          onLastClick = _a.onLastClick,
          onPageInput = _a.onPageInput,
          className = _a.className,
          isCompact = _a.isCompact,
          props = __rest(_a, ["page", "perPage", "onSetPage", "isDisabled", "lastPage", "firstPage", "pagesTitle", "toLastPage", "toNextPage", "toFirstPage", "toPreviousPage", "currPage", "paginationTitle", "onNextClick", "onPreviousClick", "onFirstClick", "onLastClick", "onPageInput", "className", "isCompact"]);

      var userInputPage = this.state.userInputPage;
      return React.createElement("nav", Object.assign({
        className: css(styles.paginationNav, className),
        "aria-label": paginationTitle
      }, props), !isCompact && React.createElement("div", {
        className: css(styles.paginationNavControl, styles.modifiers.first)
      }, React.createElement(Button, {
        variant: ButtonVariant.plain,
        isDisabled: isDisabled || page === firstPage || page === 0,
        "aria-label": toFirstPage,
        "data-action": "first",
        onClick: function onClick(event) {
          onFirstClick(event, 1);

          _this2.handleNewPage(event, 1);

          _this2.setState({
            userInputPage: 1
          });
        }
      }, React.createElement(AngleDoubleLeftIcon, null))), React.createElement("div", {
        className: styles.paginationNavControl
      }, React.createElement(Button, {
        variant: ButtonVariant.plain,
        isDisabled: isDisabled || page === firstPage || page === 0,
        "data-action": "previous",
        onClick: function onClick(event) {
          var newPage = page - 1 >= 1 ? page - 1 : 1;
          onPreviousClick(event, newPage);

          _this2.handleNewPage(event, newPage);

          _this2.setState({
            userInputPage: newPage
          });
        },
        "aria-label": toPreviousPage
      }, React.createElement(AngleLeftIcon, null))), !isCompact && React.createElement("div", {
        className: styles.paginationNavPageSelect
      }, React.createElement("input", {
        className: css(styles.formControl),
        "aria-label": currPage,
        type: "number",
        disabled: isDisabled || page === firstPage && page === lastPage || page === 0,
        min: lastPage <= 0 && firstPage <= 0 ? 0 : 1,
        max: lastPage,
        value: userInputPage,
        onKeyDown: function onKeyDown(event) {
          return _this2.onKeyDown(event, page, lastPage, onPageInput);
        },
        onChange: function onChange(event) {
          return _this2.onChange(event, lastPage);
        }
      }), React.createElement("span", {
        "aria-hidden": "true"
      }, "of ", pagesTitle ? pluralize(lastPage, pagesTitle) : lastPage)), React.createElement("div", {
        className: styles.paginationNavControl
      }, React.createElement(Button, {
        variant: ButtonVariant.plain,
        isDisabled: isDisabled || page === lastPage,
        "aria-label": toNextPage,
        "data-action": "next",
        onClick: function onClick(event) {
          var newPage = page + 1 <= lastPage ? page + 1 : lastPage;
          onNextClick(event, newPage);

          _this2.handleNewPage(event, newPage);

          _this2.setState({
            userInputPage: newPage
          });
        }
      }, React.createElement(AngleRightIcon, null))), !isCompact && React.createElement("div", {
        className: css(styles.paginationNavControl, styles.modifiers.last)
      }, React.createElement(Button, {
        variant: ButtonVariant.plain,
        isDisabled: isDisabled || page === lastPage,
        "aria-label": toLastPage,
        "data-action": "last",
        onClick: function onClick(event) {
          onLastClick(event, lastPage);

          _this2.handleNewPage(event, lastPage);

          _this2.setState({
            userInputPage: lastPage
          });
        }
      }, React.createElement(AngleDoubleRightIcon, null))));
    }
  }], [{
    key: "parseInteger",
    value: function parseInteger(input, lastPage) {
      // eslint-disable-next-line radix
      var inputPage = Number.parseInt(input, 10);

      if (!Number.isNaN(inputPage)) {
        inputPage = inputPage > lastPage ? lastPage : inputPage;
        inputPage = inputPage < 1 ? 1 : inputPage;
      }

      return inputPage;
    }
  }]);

  return Navigation;
}(React.Component);
Navigation.defaultProps = {
  className: '',
  isDisabled: false,
  isCompact: false,
  lastPage: 0,
  firstPage: 0,
  pagesTitle: '',
  toLastPage: 'Go to last page',
  toNextPage: 'Go to next page',
  toFirstPage: 'Go to first page',
  toPreviousPage: 'Go to previous page',
  currPage: 'Current page',
  paginationTitle: 'Pagination',
  onNextClick: function onNextClick() {
    return undefined;
  },
  onPreviousClick: function onPreviousClick() {
    return undefined;
  },
  onFirstClick: function onFirstClick() {
    return undefined;
  },
  onLastClick: function onLastClick() {
    return undefined;
  },
  onPageInput: function onPageInput() {
    return undefined;
  }
};